import { Injectable } from '@angular/core';
import { RequestMethod, SgWebHttpClient } from '@ds/ng-wt-helpers/http';
import { LoginDetailsService } from 'src/app/core/login/services/login-details.service';

@Injectable({
  providedIn: 'root'
})
export class CountryStatesDataService {

  countryAndStatesData;
  constructor(private http: SgWebHttpClient,
    private loginDetailsService: LoginDetailsService
  ) { }

  fetchCountryAndStatesData(){
    let countryAndStatesUrl = this.loginDetailsService.countryAndStatesUrl;
    return this.http.restAPIAsync<any>(
      RequestMethod.GET,
      countryAndStatesUrl
    );
  }

  setCountryAndStatesData(data: any){
    this.countryAndStatesData = data
  }

  getCountryAndStatesData(){
    return this.countryAndStatesData;
  }
}
